import { html } from "@ni/fast-element";
/**
 * The template for the {@link @ni/fast-foundation#TabPanel} component.
 * @public
 */
export const tabPanelTemplate = (context, definition) => html `
    <template slot="tabpanel" role="tabpanel">
        <slot></slot>
    </template>
`;
